import router from './router'
import store from './store'
import {Message} from 'element-ui'
// import {getToken} from '@/utils/auth' // get token from cookie

const whiteList = ['/login'] // 路由白名单，无需验证重定向的路由path

router.beforeEach(async(to, from, next) => {
  // 页面跳转路由的进度条开始

  try {
    // 通过获取token检测用户是否已经登录
    if (to.query.token) store.commit('user/SET_TOKEN', to.query.token)
    // 判断是否是iframe吉大嵌套过来的，是不显示头部
    if (to.query.isJida) store.commit('settings/SET_ISJIDA', to.query.isJida)
    // 判断是否存在token
    if (store.getters.token) { // 存在token
      if (to.path === 'login') { // 是否在登录页
        next({path: '/'})
      } else {
        const hasRoles = store.getters.roles && store.getters.roles.length > 0
        // 判断是不是 超级管理 useradmin 超管不需要角色的
        let isSuperAdmin = store.getters.userName.toUpperCase() === 'SUPERADMIN'
        if (hasRoles || isSuperAdmin) {
          const accessRoutes = store.getters.routes
          if ((accessRoutes && !accessRoutes.length)) {
            const accessRoutes = await store.dispatch('permission/generateRoutes')
            router.addRoutes(accessRoutes)
            next({ ...to, replace: true })
          }
          next()
        } else {
          // 判断是否获取到信息，没有去获取用户信息
          if (store.getters.userName) {
            Message({
              type: 'error',
              message: '登录失败,该用户未分配角色!'
            })
            await store.dispatch('user/resetToken')
            next(`/login?redirect=${to.path}`)
          } else {
            // 获取用户信息
            await store.dispatch('user/getInfo')
            next({ ...to, replace: true })
          }
          // await store.dispatch('user/getInfo')
          // next({ ...to, replace: true })
          // next(`/login?redirect=${to.path}`)
        }
      }
    } else {
      /* 没有token的情况 */
      // 看看是否在白名单内的路径
      if (whiteList.indexOf(to.path) !== -1) {
        // 如果在登录白名单中，可以直接登录
        next()
      } else {
        // 其他没有访问权限的页面，将重定向到登录页面
        next(`/login?redirect=${to.path}`)
      }
    }
  } catch (error) {
    await store.dispatch('user/resetToken')
    // Message({
    //   type: 'error',
    //   message: error || 'Has Error'
    // })
    next(`/login?redirect=${to.path}`)
  }
})

router.afterEach(() => {
  // 完成进度条
})



// WEBPACK FOOTER //
// ./src/permission.js